<template>
  <div class="settings">
    <div class="page-title">Widget Settings</div>
    <div class="content" v-if="!loading">
      <BaseLayoutCards>
        <BaseCard>
          <template #header>Master switch</template>
          <BaseForm :values="{ active: widget.active }" :submit="updateItem" #default="{ submittable, loading, newValues }">
            <div class="text">Make the widget visible on your storefront</div>
            <FormulateInput :outer-class="['input']" type="toggle" name="active" :label="newValues.active ? 'On' : 'Off'" />
            <BaseButton text="Save" :loading="loading" :theme="submittable ? 'purple' : 'disabled'" />
          </BaseForm>
        </BaseCard>
        <BaseCard>
          <template #header>Position</template>
          <BaseForm
            #default="{ submittable, loading }"
            :values="{ position: widget.position, padding: widget.padding.toString() }"
            :submit="updateItem"
          >
            <FormulateInput
              :outer-class="['input']"
              type="select"
              name="position"
              label="Position"
              :options="[
                { value: 'left', label: 'Left' },
                { value: 'right', label: 'Right' }
              ]"
            />
            <FormulateInput :outer-class="['input']" type="number" name="padding" label="Spacing" min="20" />
            <BaseButton text="Save" :loading="loading" :theme="submittable ? 'purple' : 'disabled'" />
          </BaseForm>
        </BaseCard>
      </BaseLayoutCards>
    </div>
    <BaseContentLoader v-else />
  </div>
</template>

<script>
import BaseLayoutCards from '@/components/BaseLayoutCards/BaseLayoutCards'
import BaseContentLoader from '@/components/BaseContentLoader/BaseContentLoader'
import BaseCard from '@/components/BaseCard/BaseCard'
import BaseForm from '@/components/BaseForm/BaseForm'
import BaseButton from '@/components/BaseButton/BaseButton'
import widgetService from '@/services/api/services/widgetService'
export default {
  components: {
    BaseLayoutCards,
    BaseContentLoader,
    BaseCard,
    BaseForm,
    BaseButton
  },
  async created() {
    this.widget = await widgetService.findMy()
    this.loading = false
  },
  data: () => ({
    widget: null,
    loading: true
  }),
  methods: {
    async updateItem(data) {
      this.widget = await widgetService.updateMy(data)
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
.page-title {
  font-size: var(--fs-title);
  font-weight: var(--fw-medium);
}
.text {
  margin-bottom: var(--spacing-4);
  color: var(--color-gray-3);
}
.input {
  margin-bottom: var(--spacing-4);
}
</style>
